// extracted by mini-css-extract-plugin
module.exports = {"container":"Nrxxky","separator":"VXGCG-","arrow":"_1eQPRX","container--mobile":"_3nsMle"};